import LoadingShape from 'components/LoadingShape';
import { IsLoadingCardContainer } from './styled';

const IsLoadingStateAndAreaCode = () => (
    <IsLoadingCardContainer>
        <LoadingShape width="40%" />
        <LoadingShape width="20%" />
    </IsLoadingCardContainer>
);

export default IsLoadingStateAndAreaCode;
